import React from 'react';
import { Link } from 'react-router-dom';

const PageLayout = ({ 
  title,
  description,
  children,
  variant = 'default', // 'default', 'hero', 'minimal'
  className = '',
  showBookCallButton = true
}) => {
  const variants = {
    default: {
      header: "bg-terrapin-blue text-white py-16",
      content: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
    },
    hero: {
      header: "bg-terrapin-blue text-white py-24",
      content: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
    },
    minimal: {
      header: "bg-white text-terrapin-blue py-8",
      content: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
    }
  };

  return (
    <div className={`min-h-screen bg-gray-50 ${className}`}>
      <header className={variants[variant].header}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {title && (
            <div className="space-y-4">
              {typeof title === 'string' ? (
                <h1 className="text-4xl font-bold">{title}</h1>
              ) : (
                title
              )}
              {description && (
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 lg:gap-0">
                  <div className={`text-xl opacity-90 ${!showBookCallButton && 'w-full'}`}>
                    {description}
                  </div>
                  {showBookCallButton && (
                    <Link 
                      to="/contact" 
                      className="btn-base bg-terrapin-red hover:bg-transparent border-2 border-terrapin-red hover:border-white text-white transition-all duration-200 whitespace-nowrap lg:ml-8"
                    >
                      Book a Call
                      <svg className="ml-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </Link>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </header>

      <main className={variants[variant].content}>
        {children}
      </main>
    </div>
  );
};

export default PageLayout; 